import { render, staticRenderFns } from "./WaterQualityStandardsModal.vue?vue&type=template&id=6959b024&scoped=true"
import script from "./WaterQualityStandardsModal.vue?vue&type=script&lang=js"
export * from "./WaterQualityStandardsModal.vue?vue&type=script&lang=js"
import style0 from "./WaterQualityStandardsModal.vue?vue&type=style&index=0&id=6959b024&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959b024",
  null
  
)

export default component.exports